import EmptyState from "../EmptyState";
import React from "react";

function getRowKey(item, index) {
	const candidate = item?.id ?? item?.key ?? item?._id;
	return typeof candidate === "string" || typeof candidate === "number" ? candidate : index;
}

function CardTableView({ className = "", nodes = [], loading, headers = [], variant = "cards" }) {
	const isDense = variant === "dense";

	if (loading) {
		return (
			<div className={`p-4 ${className}`}>
				<div role="status" className={`mb-4 min-h-[2rem] rounded-lg animate-pulse bg-gray-100`} />
				{new Array(3).fill(0).map((_, i) => (
					<div key={i} role="status" className={`mt-4 min-h-[1rem] rounded-lg animate-pulse bg-gray-100`} style={{ maxWidth: `${(10 - i) * 10}%` }} />
				))}
			</div>
		);
	}

	if (!nodes || nodes.length === 0) {
		return <EmptyState />;
	}

	return (
		<div className={className}>
			<div className={isDense ? "space-y-2" : "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3"}>
				{nodes.map((item, idx) => {
					const rowKey = getRowKey(item, idx);
					const keys = Object.keys(item || {});
					const fieldsCount = Math.max(headers?.length || 0, keys.length);

					return (
						<div
							key={rowKey}
							className={
								isDense
									? "p-3 bg-canvas border border-surface/30 rounded-lg shadow-sm"
									: "p-4 bg-canvas border border-surface/30 rounded-xl shadow-sm"
							}
						>
							<div className={isDense ? "grid grid-cols-1 gap-2" : "grid grid-cols-1 gap-3"}>
								{new Array(fieldsCount).fill(0).map((_, i) => {
									const label = headers?.[i]?.label ?? keys[i] ?? "";
									const valueKey = keys[i];
									const value = valueKey ? item[valueKey] : null;

									if (!label && value == null) return null;

									return (
										<div key={i} className="min-w-0">
											{label ? <div className="text-xs font-semibold text-secondary">{label}</div> : null}
											<div className="text-sm text-dark break-words">{value ?? "-"}</div>
										</div>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

const TableView = ({ className = "", nodes = [], loading, headers = [], variant = "cards" }) => {
	return <CardTableView className={className} nodes={nodes} loading={loading} headers={headers} variant={variant} />;
};

export default TableView;
